.modal {
  width: 100%;
  max-width: 650px;
  padding-right: 3rem;
  padding-left: 3rem;
}

.wrapper {
  & > * + * {
    margin-top: 2rem;
  }
}
